import Keycloak from 'keycloak-js';
import { API_BASE, apiFetch } from '../apilib/api-base.js';
export const fetchKeycloakConfig = async () => {
    return apiFetch().url(`${API_BASE}/System/PublicServices`).json().fetch();
};
export class KeycloakIdentityProvider {
    constructor(keycloak) {
        this.retrieveAuthString = async () => {
            await this.updateToken();
            if (this.keycloak.token === undefined) {
                throw Error('token missing');
            }
            return `Apa-Bearer ${this.keycloak.token}`;
        };
        this.getOutdatedAuthString = () => {
            if (this.keycloak.token === undefined) {
                throw Error('token missing');
            }
            return `Apa-Bearer ${this.keycloak.token}`;
        };
        this.updateToken = async () => {
            var _a, _b, _c;
            const refreshTokenExpirationUnixTime = (_b = (_a = this.keycloak.refreshTokenParsed) === null || _a === void 0 ? void 0 : _a.exp) !== null && _b !== void 0 ? _b : 0;
            if (new Date() > new Date((refreshTokenExpirationUnixTime + 100) * 1000)) {
                // NOTE: keycloak.updateToken does not update the refresh token.
                // When we have outdated refresh token, each keycloak.updateToken
                // works, but redirects user to keycloak and it does not update refresh token.
                // So it is better to log user out explicitly and force him to get
                // new refresh token in keycloak by logging in again.
                await this.keycloak.logout();
            }
            await this.keycloak.updateToken(50);
            return (_c = this.keycloak.authenticated) !== null && _c !== void 0 ? _c : false;
        };
        this.logOut = async () => this.keycloak.logout();
        if (!keycloak.authenticated) {
            throw new Error('keycloak is not authenticated');
        }
        this.keycloak = keycloak;
        this.keycloak.onTokenExpired = () => {
            void this.updateToken();
        };
    }
}
export const createKeycloakIdentityProvider = async () => {
    const config = await fetchKeycloakConfig();
    // NOTE: Keycloak is not typed correctly. It exports a default class and a namespace with the same name.
    // @ts-expect-error Keycloak is not typed correctly
    const keycloak = new Keycloak(config.apaConfiguration);
    await keycloak.init({ onLoad: 'login-required', checkLoginIframe: false });
    return new KeycloakIdentityProvider(keycloak);
};
